const normalize = value => String(value || '').trim().toLowerCase().replace(/[–—]/g, '-').replace(/_/g, ' ');

export const isDispatchedStatusOverride = value => normalize(value) === 'dispatched';
export const isReceivedStatus = value => ['received', 'request received'].includes(normalize(value));

export const getClientStatus = value => {
  const status = normalize(value);
  if (!status) return { label: 'Request Received', tone: 'pending' };
  if (status === 'dispatched') return { label: 'Dispatched', tone: 'dispatched' };
  if (status.includes('unscheduled') || status.includes('past-due') || status.includes('past due')) {
    return { label: 'Scheduling in Progress', tone: 'scheduling' };
  }
  if (status.includes('waiting on client') || status.includes('client response')) {
    return { label: 'Awaiting Your Response', tone: 'attention' };
  }
  if (status.includes('scheduled')) return { label: 'Scheduled', tone: 'scheduled' };
  if (status.includes('in progress')) return { label: 'Service in Progress', tone: 'progress' };
  if (status.includes('complete') || status.includes('closed') || status.includes('resolved')) return { label: 'Service Complete', tone: 'complete' };
  if (status.includes('cancel')) return { label: 'Cancelled', tone: 'neutral' };
  if (status === 'pending') return { label: 'Request Received', tone: 'pending' };
  return { label: String(value).trim(), tone: 'pending' };
};
